<template>
  <div
    class="w-full fixed right-10 xl:right-4 bottom-4 flex flex-row justify-end gap-4"
  >
    <div
      class="rounded-lg text-2xl py-4 px-8 cursor-pointer font-oswald transition duration-300 border border-gray-roc bg-black hover:bg-gray-roc text-white leading-none"
      title="Start new layout from current"
      @click="copyLayout"
    >
      COPY (EDIT)
    </div>
  </div>
</template>

<script>
export default {
  emits: ['copy'],
  setup(_, context) {
    return {
      copyLayout() {
        context.emit('copy');
      }
    }
  }
};
</script>
